<template>
  <div class="box">Brak wyników</div>
</template>

<script>
export default {
  name: "DodEmptyList",
};
</script>
<style scoped>
.box {
  width: 100%;
  background: rgb(251, 116, 116);
  color: #fff;
  text-align: center;
  font-size: 16px;
  border-radius: 8px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>